// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"471059b2","305":"3bf627fb"}[chunkId] + ".chunk.js";
};